import { render, staticRenderFns } from "./SearchTag2.vue?vue&type=template&id=4d79e03a&scoped=true&lang=pug&"
import script from "./SearchTag2.vue?vue&type=script&lang=js&"
export * from "./SearchTag2.vue?vue&type=script&lang=js&"
import style0 from "./SearchTag2.vue?vue&type=style&index=0&id=4d79e03a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d79e03a",
  null
  
)

export default component.exports